import { STORAGE, API_ENDPOINT } from "../../constants";
import { HTTP } from "../http";
import { StorageService } from "../storage";

export const BalanceService = {
  getBalance: () => {
    const { _id } = StorageService.get(STORAGE.PERIOD);
    return HTTP.get<any, any>(`${API_ENDPOINT}operation/balance/${_id}`);
  },
};
